module.exports = "/_next/static/images/MakeEveryInteractionMeaningful@2x-be6335a1dc66ad245ac3c13267d9ec6a.webp";